import { render, staticRenderFns } from "./LogoDatePanel.vue?vue&type=template&id=bd4e13ca&scoped=true&"
import script from "./LogoDatePanel.vue?vue&type=script&lang=js&"
export * from "./LogoDatePanel.vue?vue&type=script&lang=js&"
import style0 from "./LogoDatePanel.vue?vue&type=style&index=0&id=bd4e13ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e13ca",
  null
  
)

export default component.exports